import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Typography, units } from '@hbf/dsl';
import { Variant } from './types';

const useStyles = makeStyles()(() => ({
  paragraph: {
    fontSize: units.rem(0.85),
    textTransform: 'capitalize',
    marginBottom: units.rem(0.5),
  },
  div: {
    fontSize: units.rem(0.85),
    fontWeight: 'normal',
  },
}));

interface Props {
  children: React.ReactNode;
  dataTestLocator: string;
  variant: Variant;
}

const Wrapper: React.FC<Props> = ({ children, dataTestLocator, variant }) => {
  const { classes } = useStyles();

  const variants = {
    paragraph: (props: { children: React.ReactNode }) => (
      <Typography.Paragraph
        component="p"
        className={classes.paragraph}
        {...props}
      >
        {children}
      </Typography.Paragraph>
    ),
    div: (props: { children: React.ReactNode }) => (
      <div className={classes.div} {...props}>
        {children}
      </div>
    ),
    caption: (props: { children: React.ReactNode }) => (
      <Typography.Caption color="muted" {...props}>
        {children}
      </Typography.Caption>
    ),
  };

  const Element = variants[variant];

  return <Element data-test-locator={dataTestLocator}>{children}</Element>;
};

export { Wrapper };
